import React, { useEffect } from "react";
import { Markdown } from "component-library";
import { LegalPage as LegalPageData } from "@shared/praxis-config";
import { useLocalizedText } from "../praxis-config/use-localized-text";

const LegalMarkdown: React.FC<{
  text: Extract<LegalPageData, { type: "markdown" }>["text"];
}> = ({ text }) => {
  const markdown = useLocalizedText(text);

  return (
    <div className="max-w-3xl mx-auto p-6 prose prose-lg">
      <Markdown>{markdown}</Markdown>
    </div>
  );
};

export const LegalPage: React.FC<{ page: LegalPageData }> = ({ page }) => {
  useEffect(() => {
    if (page.type === "redirect") {
      window.location.href = page.url;
    }
  }, [page]);

  if (page.type === "redirect") {
    return null;
  }

  return <LegalMarkdown text={page.text} />;
};
